// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"78415ee9","51":"653827e3","80":"a9122bfa","213":"1666e52c","316":"a1468771","455":"df0b5293","572":"b3591c20","769":"99748281"}[chunkId] + ".chunk.js";
};